<img src="/assets/images/illust/simple-question.svg" />

<div class="text">
  {{ translateKey | translate }}
</div>
<div class="cta"></div>
